module.exports = __webpack_public_path__ + "static/img/03.cdf37e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/altcoin/03.png
// module id = sIZI
// module chunks = 0